import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const InvoiceAddPaymentDialogTourConfig: AgTechTourConfig = {
    id: 'invoice-add-payment-dialog-tour',
    name: 'Add Payment Tour',
    steps: [
        {
            targetId: 'invoice-add-payment-info',
            title: 'Invoice Summary',
            description: 'A read-only reminder of which invoice you are paying: its number, date and current status.',
            position: 'bottom',
        },
        {
            targetId: 'invoice-add-payment-payer',
            title: 'Payer and Amount',
            description: 'Choose who made the payment and how much they paid. The amount defaults to the balance still owed after any earlier payments, so change it for a partial payment.',
            position: 'bottom',
        },
        {
            targetId: 'invoice-add-payment-type',
            title: 'Payment Type and Details',
            description: 'Select how the payment was made (cash, check, card and so on) and add optional details such as a check number.',
            position: 'bottom',
        },
        {
            targetId: 'invoice-add-payment-previous',
            skipIfMissing: true,
            title: 'Previous Payments',
            description: 'Payments already recorded against this invoice. This section only shows when earlier payments exist.',
            position: 'top',
        },
    ]
}
